<template>
  <el-popover
    class="help-tip-wrap"
    :placement="placement"
    width="260"
    :title="title"
    trigger="hover"
    :content="content"
  >
    <i slot="reference" class="el-icon-question help-tip"></i>
  </el-popover>
</template>

<script>
// Значок «?» с подсказкой при наведении - один вид для всех подсказок внесения данных
export default {
  name: "helpTip",
  props: {
    title: { type: String, default: "" },
    content: { type: String, required: true },
    placement: { type: String, default: "bottom-end" },
  },
};
</script>

<style scoped>
/* Рядом с длинным текстом значок не сжимается */
.help-tip-wrap {
  flex-shrink: 0;
}
.help-tip {
  color: #c0c4cc;
  font-size: 16px;
  vertical-align: middle;
  cursor: help;
  transition: color 0.15s;
}
.help-tip:hover {
  color: #409eff;
}
</style>
